package com.milta.core.localization.translations.sq

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Skano një etiketë",
    analysingTitle = "Po lexohet etiketa…",
    analysingSubtitle = "Po kërkojmë emrin, adresën dhe numrin e telefonit të marrësit. Kërkohen vetëm pak sekonda.",
    reviewTitle = "Konfirmo dërgesën",
    deliveryDetectedLabel = "Dërgesë e zbuluar",
    allReadableLabel = "Gjithçka e lexueshme",
    fieldToCompleteSingularSuffix = "fushë për t'u plotësuar",
    fieldToCompletePluralSuffix = "fusha për t'u plotësuar",
    recipientNotDetectedValue = "Nuk u zbulua",
    addressNotDetectedValue = "Nuk u zbulua",
    phoneNotDetectedValue = "Nuk u zbulua",
    fieldRequiredWarning = "Fushë e detyrueshme për të shtuar dërgesën",
    recipientCorrectionPlaceholder = "Vendosni marrësin…",
    addressCorrectionPlaceholder = "Vendosni adresën…",
    unreadableTitle = "Etiketë e palexueshme.",
    unreadableMessage = "Bëni një foto të re të kornizuar tek etiketa, të ndriçuar mirë dhe pa reflektim.",
    maxAttemptsMessage = "Plotësoni këtë dërgesë manualisht, ose rifilloni skanimin me një foto të re.",
)
